import { render, staticRenderFns } from "./TopPostDomain.vue?vue&type=template&id=535a63d2&scoped=true&"
import script from "./TopPostDomain.vue?vue&type=script&lang=js&"
export * from "./TopPostDomain.vue?vue&type=script&lang=js&"
import style0 from "./TopPostDomain.vue?vue&type=style&index=0&id=535a63d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535a63d2",
  null
  
)

export default component.exports